import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["editor", "enabledInput", "deceasedCheckbox", "deceasedDateField", "deceasedDateInput", "editButton"]

  connect() {
    this.updateEditor()
    this.updateDeceased()
  }

  showEditor(event) {
    event.preventDefault()
    this.enabledInputTarget.value = "1"
    this.updateEditor()
  }

  updateDeceased() {
    const deceasedSelected = this.deceasedCheckboxTarget.checked

    this.deceasedDateFieldTarget.classList.toggle("hidden", !deceasedSelected)
    this.deceasedDateInputTarget.required = deceasedSelected

    if (!deceasedSelected) {
      this.deceasedDateInputTarget.value = ""
    }
  }

  updateEditor() {
    const enabled = this.enabledInputTarget.value === "1"
    this.editorTarget.classList.toggle("hidden", !enabled)
    if (this.hasEditButtonTarget) {
      this.editButtonTarget.classList.toggle("inline-flex", !enabled)
      this.editButtonTarget.classList.toggle("hidden", enabled)
    }
  }
}
